import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as n, normalizeClass as o, createElementVNode as r } from "vue";
import { _ as d } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconCornerDownLeft",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ r("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.854 4.646a.5.5 0 0 1 0 .708L3.207 7l-.5.5.5.5 1.647 1.646a.5.5 0 0 1-.708.708l-2.5-2.5a.5.5 0 0 1 0-.708l2.5-2.5a.5.5 0 0 1 .708 0Z",
  fill: "currentColor"
}, null, -1), u = /* @__PURE__ */ r("path", {
  d: "M10.5 2a.5.5 0 0 0-1 0v3.5A1.5 1.5 0 0 1 8 7H3.207l-.5.5.5.5H8a2.5 2.5 0 0 0 2.5-2.5V2Z",
  fill: "currentColor"
}, null, -1), f = [
  _,
  u
];
function m(a, h, i, p, v, e) {
  return n(), l("svg", {
    "aria-label": i.ariaLabel,
    class: o([e.iconSizeClass, "d-icon d-icon--corner-down-left"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Corner Down Left",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, f, 10, c);
}
const g = /* @__PURE__ */ d(s, [["render", m]]);
export {
  g as default
};
//# sourceMappingURL=corner-down-left.js.map
